import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { selectedFiltersFromQueryParams } from "../utils/selectedFiltersFromQueryParams";
import useSearchParamsHandler from "./useSearchParamsHandler";
import {
  categoriesPageModeAtom,
  filterInfoAtom,
  selectedFiltersAtom,
} from "../atom/listings";
import {
  filterInfoAtom as productsFiltersInfoAtom,
  selectedFiltersAtom as productsSelectedFiltersAtom,
} from "../atom/products";
import { useAtom } from "jotai";

const useSelectedFilter = () => {
  const location = useLocation();
  const [categoriesPageMode] = useAtom(categoriesPageModeAtom);

  const isListingsMode = categoriesPageMode === "listings";
  const [selectedFilters, setSelectedFilters] = useAtom(
    isListingsMode ? selectedFiltersAtom : productsSelectedFiltersAtom,
  );
  const [filterInfo] = useAtom(
    isListingsMode ? filterInfoAtom : productsFiltersInfoAtom,
  );

  const { params, deleteParam, addOrUpdateParam, clearParams } =
    useSearchParamsHandler();

  const queryParamsArr = Object.entries(params);

  const queryString = queryParamsArr.map((item) => {
    return {
      title: item[0],
      value: item[1],
    };
  });

  useEffect(() => {
    const newFilters = selectedFiltersFromQueryParams(queryString, filterInfo);
    setSelectedFilters(newFilters);
    // eslint-disable-next-line
  }, [location.search]);

  const selectFilter = (filter) => {
    const currentValue = (filter.flag || filter.value).toLowerCase();
    const isSelected = selectedFilters[filter.title].some(
      (item) =>
        (item.value + "").toLowerCase() === currentValue ||
        (item.flag + "").toLowerCase() === currentValue ||
        (item.query + "").toLowerCase() === currentValue,
    );

    if (isSelected) {
      deleteParam(filter.title, filter.flag || filter.value);
    } else {
      addOrUpdateParam(filter.title, filter.flag || filter.value);
    }
  };

  return {
    selectedFilters,
    setSelectedFilters,
    clearParams,
    deleteParam,
    addOrUpdateParam,
    selectFilter,
  };
};

export default useSelectedFilter;
